(() => {
    const MEDIA_ID_PATTERN = /(?:^|-)\d+$/;

    const getPicker = (productView) => {
        const pickers = Array.from(productView.querySelectorAll('variant-radios'));

        return pickers.find((picker) => picker.offsetParent !== null) || pickers[0];
    };

    const getMediaId = (slide) => {
        const media = slide && (slide.matches('[data-media-id]') ? slide : slide.querySelector('[data-media-id]'));

        if (!media) return null;

        const value = String(media.getAttribute('data-media-id') || '');
        const match = value.match(MEDIA_ID_PATTERN);

        return match ? match[0].replace('-', '') : null;
    };

    const getColorFieldset = (picker) => {
        const fieldsets = Array.from(picker.querySelectorAll('fieldset[data-option-index]'));

        return fieldsets.find((fieldset) => fieldset.querySelector('input[data-filter]'))
            || fieldsets.find((fieldset) => fieldset.classList.contains('product-form__swatch'))
            || fieldsets.find((fieldset) => /color|colour|لون/i.test(fieldset.querySelector('.form__label')?.textContent || ''));
    };

    const getCurrentOptions = (picker) => Array.from(picker.querySelectorAll('fieldset[data-option-index]')).map((fieldset) => {
        const selected = fieldset.querySelector('input:checked');

        return selected ? selected.value : null;
    });

    const getFieldsets = (picker) => Array.from(picker.querySelectorAll('fieldset[data-option-index]'))
        .sort((first, second) => Number(first.getAttribute('data-option-index')) - Number(second.getAttribute('data-option-index')));

    const getVariantData = (picker) => {
        const json = picker.querySelector('script[type="application/json"]');

        if (!json) return [];

        try {
            return JSON.parse(json.textContent);
        } catch (error) {
            return [];
        }
    };

    const getSlideFilter = (slide) => Array.from(slide.classList).find((className) => className.indexOf('filter-') === 0);

    const getVariantForMedia = (picker, mediaId) => {
        const selectedOptions = getCurrentOptions(picker);
        const matchingVariants = getVariantData(picker).filter((variant) => {
            return variant.featured_media && String(variant.featured_media.id) === mediaId;
        });

        if (!matchingVariants.length) return null;

        const matchingCurrentOptions = matchingVariants.filter((variant) => {
            return variant.options.every((option, index) => !selectedOptions[index] || selectedOptions[index] === option);
        });

        return matchingCurrentOptions.find((variant) => variant.available)
            || matchingCurrentOptions[0]
            || matchingVariants.find((variant) => variant.available)
            || matchingVariants[0];
    };

    const selectVariant = (picker, variant) => {
        const inputs = getFieldsets(picker).map((fieldset) => {
            const optionIndex = Number(fieldset.getAttribute('data-option-index'));

            return Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((input) => {
                return input.value === variant.options[optionIndex];
            });
        });

        if (inputs.length !== variant.options.length || inputs.some((input) => !input)) return false;

        const changedInputs = inputs.filter((input) => !input.checked);

        if (!changedInputs.length) return true;

        inputs.forEach((input) => {
            input.checked = true;
        });
        changedInputs[changedInputs.length - 1].dispatchEvent(new Event('change', { bubbles: true }));

        return true;
    };

    const findGroupedImageInput = (fieldset, slide) => {
        const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        const filter = getSlideFilter(slide);

        if (filter) {
            const input = inputs.find((item) => item.getAttribute('data-filter') === `.${filter}`);

            if (input) return input;
        }

        return null;
    };

    const syncPicker = (gallery, slide) => {
        const productView = gallery.closest('.productView');
        const picker = productView && getPicker(productView);
        const mediaId = getMediaId(slide);

        if (!picker || !mediaId) return;

        const variant = getVariantForMedia(picker, mediaId);

        if (variant && selectVariant(picker, variant)) return;

        const fieldset = getColorFieldset(picker);

        if (!fieldset) return;

        const input = findGroupedImageInput(fieldset, slide);

        if (!input || input.checked) return;

        input.click();
    };

    const syncFromSlick = (slider, slick, currentSlide) => {
        const slide = slick.$slides && slick.$slides.get(currentSlide);

        if (slide) syncPicker(slider, slide);
    };

    const syncFromCurrentSlickSlide = (slider) => {
        const slide = slider.querySelector('.slick-current:not(.slick-cloned)')
            || slider.querySelector('.slick-current');

        if (slide) syncPicker(slider, slide);
    };

    const initSlickSlider = (slider) => {
        if (slider.dataset.haloGalleryVariantSyncReady === 'true') return;

        slider.dataset.haloGalleryVariantSyncReady = 'true';

        let timeout;
        const scheduleSync = () => {
            window.clearTimeout(timeout);
            timeout = window.setTimeout(() => syncFromCurrentSlickSlide(slider), 180);
        };

        if (window.jQuery) {
            window.jQuery(slider).on('afterChange.haloGalleryVariantSync', (event, slick, currentSlide) => {
                syncFromSlick(slider, slick, currentSlide);
            });
        }

        slider.addEventListener('touchend', scheduleSync, { passive: true });
        slider.addEventListener('pointerup', scheduleSync, { passive: true });
        slider.addEventListener('click', (event) => {
            if (event.target.closest('.slick-arrow, .slick-dots button')) scheduleSync();
        });
    };

    const syncFromNativeSlider = (component) => {
        const slider = component.querySelector('.productView-mediaList');
        const slides = slider && Array.from(slider.querySelectorAll('.productView-mediaItem'));

        if (!slider || !slides?.length) return;

        const slideWidth = slides[0].getBoundingClientRect().width;
        const index = slideWidth ? Math.round(slider.scrollLeft / slideWidth) : 0;
        const slide = slides[Math.max(0, Math.min(index, slides.length - 1))];

        if (slide) syncPicker(component, slide);
    };

    const initNativeSlider = (component) => {
        if (component.dataset.haloGalleryVariantSyncReady === 'true') return;

        const slider = component.querySelector('.productView-mediaList');

        if (!slider) return;

        component.dataset.haloGalleryVariantSyncReady = 'true';

        let timeout;
        const scheduleSync = () => {
            window.clearTimeout(timeout);
            timeout = window.setTimeout(() => syncFromNativeSlider(component), 80);
        };

        slider.addEventListener('scroll', scheduleSync, { passive: true });
        component.querySelectorAll('.slider-button').forEach((button) => {
            button.addEventListener('click', scheduleSync);
        });
    };

    const init = () => {
        document.querySelectorAll('.productView slider-component').forEach(initNativeSlider);
        document.querySelectorAll('.productView-nav').forEach(initSlickSlider);

        if (!window.jQuery) return;

        const $document = window.jQuery(document);

        $document.on('click.haloGalleryVariantSync', '.productView-thumbnail, .productView-nav .productView-image, .productView-mediaItem', (event) => {
            syncPicker(event.currentTarget, event.currentTarget);
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }
})();
